const iconMappings = {
  'nature': 'i-ph-leaf-duotone',
  'solidarity': 'i-ph-handshake-duotone',
  'health': 'i-ph-heartbeat-duotone',
  'culture': 'i-ph-mask-happy-duotone',
  'education': 'i-ph-graduation-cap-duotone',
  'employment': 'i-ph-briefcase-duotone',
  'sport': 'i-ph-barbell-duotone',
  'humanitarian-aid': 'i-ph-hand-heart-duotone',
  'animals': 'i-ph-paw-print-duotone',
  'social': 'i-ph-users-three-duotone',
  'admin-tasks': 'i-ph-bank-duotone',
  'counseling': 'i-ph-compass-duotone',
  'collecting': 'i-ph-archive-duotone',
  'info-tech': 'i-ph-desktop-duotone',
  'logistics': 'i-ph-truck-duotone',
  'international': 'i-ph-globe-simple-duotone',
  'literacy': 'i-ph-text-aa-duotone',
  'gardening': 'i-ph-potted-plant-duotone',
  'entertainment': 'i-ph-mask-happy-duotone',
  'communication': 'i-ph-presentation-chart-duotone',
  'psycho-support': 'i-ph-lifebuoy-duotone',
  'crafting-diy': 'i-ph-paint-brush-duotone',
  'management': 'i-ph-users-three-duotone',
  'repairing-diy': 'i-ph-wrench-duotone',
  'visiting': 'i-ph-car-duotone',
  'delivery': 'i-ph-shopping-cart-duotone',
  'learning-support': 'i-ph-graduation-cap-duotone',
  'translation': 'i-ph-translate-duotone',
  'partnership': 'i-ph-handshake-duotone',
  'operator': 'i-ph-chat-circle-dots-duotone',
  'human-resources': 'i-ph-user-square-duotone',
  'board-member': 'i-ph-shooting-star-duotone',
  'legal': 'i-ph-scales-duotone',
  'reception': 'i-ph-info-duotone',
  'training': 'i-ph-books-duotone',
  'accounting': 'i-ph-bank-duotone',
  'first-aid': 'i-ph-first-aid-kit-duotone',
  'project-management': 'i-ph-folder-notch-open-duotone',
  'mentoring': 'i-ph-megaphone-duotone',
}

export default function(slug) {
  return iconMappings[slug]
}
